<template>
  <!-- Sidebar-->
  <b-collapse v-model="menu_visible" id="sidebar">
    <div class="sidebar-heading">
      <a @click="link_close({ name: 'Main' })" class="more">
        <img src="/img/logo_white.png" />
      </a>
    </div>
    <div class="sidebar-body">
      <ul>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu1'"
                :class="{ active: menu_num === 1 }"
              >
                <i class="material-icons">person</i>
                <span>{{ $t("menu.membership.membership") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu1" v-model="visible1" accordion="my-accordion">
            <div class="collapse-item font-montserrat">
              <a
                class="more"
                @click="forceRerender({ name: 'MemberList' })"
                :class="{ active: sub_menu_num === 11 }"
                ><span>{{ $t("menu.membership.member") }}</span></a
              >
              <a
                class="more"
                @click="forceRerender({ name: 'LockerView' })"
                :class="{ active: sub_menu_num === 12 }"
                ><span>{{ $t("menu.membership.locker_room") }}</span></a
              >
              <!-- <router-link
                :to="{ name: 'PointList' }"
                :class="{ active: sub_menu_num === 13 }"
                ><span>{{ $t("menu.bucks_management") }}</span></router-link
              > -->
            </div>
          </b-collapse>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                @click="link_close({ name: 'bookingDate' })"
                :class="{ active: menu_num === 2 }"
              >
                <i class="material-icons">emoji_events</i>
                <span>{{ $t("menu.booking.booking") }}</span>
              </button>
            </div>
          </nav>
          <!-- <b-collapse id="menu2" v-model="visible2" accordion="my-accordion">
            <div class="collapse-item font-montserrat">
              <a
                class="more"
                @click="forceRerender({ name: 'BookingDay' })"
                :class="{ active: sub_menu_num === 21 }"
                ><span>{{ $t("menu.booking.date") }}</span>
              </a>
              <a
                class="more"
                @click="forceRerender({ name: 'BookingTable' })"
                :class="{ active: sub_menu_num === 22 }"
                ><span>{{ $t("menu.booking.list") }}</span>
              </a>
            </div>
          </b-collapse> -->
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu3'"
                :class="{ active: menu_num === 3 }"
              >
                <i class="material-icons">my_location</i>
                <span>{{ $t("menu.simulator.simulator") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu3" v-model="visible3" accordion="my-accordion">
            <div class="collapse-item font-montserrat">
              <a
                class="more"
                @click="forceRerender({ name: 'RoomList' })"
                :class="{ active: sub_menu_num === 31 }"
                ><span>{{ $t("menu.simulator.hittingbay") }}</span>
              </a>
              <a
                class="more"
                @click="forceRerender({ name: 'RoomTable' })"
                :class="{ active: sub_menu_num === 32 }"
                ><span>{{ $t("menu.simulator.game") }}</span>
              </a>
            </div>
          </b-collapse>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu4'"
                :class="{ active: menu_num === 4 }"
              >
                <i class="material-icons">settings</i>
                <span>{{ $t("menu.setting.setting") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu4" v-model="visible4" accordion="my-accordion">
            <div class="collapse-item font-montserrat">
              <a
                class="more"
                @click="forceRerender({ name: 'Profile' })"
                :class="{ active: sub_menu_num === 41 }"
                ><span>{{ $t("menu.setting.profile") }}</span>
              </a>
              <a
                class="more"
                @click="forceRerender({ name: 'PasswordChange' })"
                :class="{ active: sub_menu_num === 42 }"
                ><span>{{ $t("menu.setting.password_change") }}</span></a
              >
              <a
                class="more"
                @click="forceRerender({ name: 'EmailChange' })"
                :class="{ active: sub_menu_num === 43 }"
                ><span>{{ $t("menu.setting.email_change") }}</span>
              </a>
              <a
                class="more"
                @click="forceRerender({ name: 'Option' })"
                :class="{ active: sub_menu_num === 44 }"
                ><span>{{ $t("menu.setting.option") }}</span>
              </a>
              <a
                class="more"
                @click="forceRerender({ name: 'Notice' })"
                :class="{ active: sub_menu_num === 45 }"
                ><span>{{ $t("menu.setting.owner_notice") }}</span>
              </a>
            </div>
          </b-collapse>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                @click="link_close({ name: 'TournamentList' })"
                :class="{ active: menu_num === 5 }"
              >
                <i class="material-icons">emoji_events</i>
                <span>{{ $t("menu.tournament.tournament") }}</span>
              </button>
            </div>
          </nav>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu6'"
                :class="{ active: menu_num === 6 }"
              >
                <i class="material-icons">interests</i>
                <span>{{ $t("menu.event.event") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu6" v-model="visible6" accordion="my-accordion">
            <div class="collapse-item font-montserrat">
              <a
                class="more"
                @click="forceRerender({ name: 'MiniGameList' })"
                :class="{ active: sub_menu_num === 61 }"
                ><span>{{ $t("menu.event.minigame") }}</span>
              </a>
              <a
                class="more"
                @click="forceRerender({ name: 'MiniGameWinningList' })"
                :class="{ active: sub_menu_num === 62 }"
                ><span>{{ $t("menu.event.minigame_winners") }}</span>
              </a>
            </div>
          </b-collapse>
        </li>

        <!--
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu7'"
                :class="{ active: menu_num === 7 }"
              >
                <i class="material-icons">handyman</i>
                <span>피팅관리</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu7" v-model="visible7" accordion="my-accordion">
            <div class="collapse-item">
              <router-link
                :to="{ name: 'FittingList', query: { goodstype: '0' } }"
                :class="{ active: sub_menu_num === 71 }"
                ><span>피팅현황</span>
              </router-link>
              <router-link
                :to="{ name: 'SaleList', query: { goodstype: '0' } }"
                :class="{ active: sub_menu_num === 72 }"
                ><span>판매현황</span></router-link
              >
              <router-link
                :to="{ name: 'CustomerList', query: { category: '0' } }"
                :class="{ active: sub_menu_num === 73 }"
                ><span>A/S현황</span>
              </router-link>
            </div>
          </b-collapse>
        </li> -->
      </ul>
    </div>
    <div class="time-zone">
      <dfn
        class="time-zone-mark badge rounded-pill bg-orange"
        title="Connect time"
        >CT</dfn
      >
      {{ timezone_name }} (UTC
      {{ timezone_offset >= 0 ? "+" + timezone_offset : timezone_offset }}:00)
      <p>
        <span class="me-1">
          <dfn
            class="time-zone-mark badge rounded-pill bg-green"
            title="Standard time"
            >ST</dfn
          >
        </span>
        <span>
          <dfn
            class="time-zone-mark badge rounded-pill bg-orange"
            title="Connect time"
            >CT</dfn
          >
          {{ $t("text.common.time-zone-info") }}
        </span>
      </p>
    </div>
  </b-collapse>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menu: 0,
      loging: this.$store.state.status === "success",
      userid: this.$store.state.userId,
      userName: this.$store.state.userName,
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible6: false,
      visible7: false,
      menu_visible: true,
      timezone_name: this.$store.state.timezone.timezone_name,
      timezone_offset: this.$store.state.timezone.timezone_offset,
    };
  },
  methods: {
    forceRerender: function (val) {
      if (window.innerWidth < 1000) {
        this.menu_visible = false;
      }

      this.$store.commit("setSearchData", {});
      this.$store.commit("forceRerender");
      this.$router.push(val).catch(() => {});
    },
    check_mobile: function () {
      let filter = "win16|win32|win64|mac|macintel";
      if (navigator.platform) {
        if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
          this.is_mobile = true;
        } else {
          this.is_mobile = false;
        }
      }
    },
    link_close(val) {
      this.visible1 = false;
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      this.visible6 = false;
      this.visible7 = false;
      this.forceRerender(val);
    },
    resizeEvent() {
      //window.addEventListener('resize', this.widthCheck)
    },
    widthCheck() {
      if (window.innerWidth < 1000) {
        this.menu_visible = false;
      } else {
        this.menu_visible = true;
      }
    },
  },
  mounted() {
    if (this.$store.state.status === "success") {
      this.loging = true;
    }
    this.widthCheck();
  },
  beforeDestroy() {
    this.widthCheck();
  },
  created() {
    this.check_mobile();
    this.widthCheck();
    if (this.menu_num === 1) {
      this.visible1 = true;
    } else if (this.menu_num === 2) {
      this.visible2 = true;
    } else if (this.menu_num === 3) {
      this.visible3 = true;
    } else if (this.menu_num === 4) {
      this.visible4 = true;
    } else if (this.menu_num === 6) {
      this.visible6 = true;
    } else if (this.menu_num === 7) {
      this.visible7 = true;
    }
  },
  computed: {
    logo: function () {
      // if (this.$route.name === 'Main' || this.$route.name === 'ForgotPassword' || this.last_scroll_position > 0)
      return "/img/logo_black.png";
      // else return '/img/logo_white.png'
    },
    menu_num: function () {
      return this.$route.meta.menu_num || 0;
    },
    sub_menu_num: function () {
      return this.$route.meta.sub_menu_num || 0;
    },
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        this.widthCheck();
      }
    },
    menu_visible: function () {
      this.$emit("menu_v", this.menu_visible);
    },
    "$store.state.timezone": {
      deep: true,
      handler: function (val, oldVal) {
        this.timezone_name = val.timezone_name;
        this.timezone_offset = val.timezone_offset;
      },
    },
  },
};
</script>
